<template>
  <div id="contact-form-modal">
    <div class="modal-container">
      <div class="close-btn-photo">
        <span @click="$emit('close')"><i class="fa-solid fa-xmark fa-lg"></i></span>
      </div>

      <div class="contact-container mt-5">
        <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/plaquette-commerciale-entreprise.webp" alt="">
        <p v-if="!success" class="raleway-reg-p15 text-center" :class="isPhone ? '' : 'mt-3'">
          Remplissez vos informations pour accéder au téléchargement de notre plaquette.
        </p>

        <form v-if="!success" class="contact-form w-100" @submit.prevent="submitForm" novalidate>
          <div class="row line-form mb-2">
            <label class="col-12">
              Nom *
              <input v-model="contact.last_name" type="text" />
            </label>
          </div>
          <div class="row line-form mb-2">
            <label class="col-12">
              Prénom *
              <input v-model="contact.first_name" type="text" />
            </label>
          </div>
          <div class="row line-form mb-2">
            <label class="col-12">
              Entreprise *
              <input v-model="contact.entreprise" type="text" />
            </label>
          </div>
          <div class="row line-form mb-2">
            <label class="col-12">
              Adresse e-mail professionnelle *
              <input v-model="contact.email" type="email" />
            </label>
          </div>
          <div class="row line-form mb-2">
            <label class="col-12">
              Numéro de téléphone *
              <input v-model="contact.phone" type="tel" />
            </label>
          </div>

          <p :class="isPhone ? 'raleway-reg-p13' : 'raleway-reg-p15'">* Champs obligatoires</p>

          <p v-if="formError" class="text-danger text-center raleway-reg-p13">Veuillez remplir tous les champs obligatoires.</p>

          <div class="d-flex w-100 justify-content-center align-items-center" :class="isPhone ? 'px-4' : ''">
            <button type="submit" class="hortense-btn-primary">TÉLÉCHARGER LA PLAQUETTE</button>
          </div>
        </form>

        <div v-if="success" class="text-center mt-3">
          <div class="d-flex flex-column align-items-center justify-content-center">
              <p class="raleway-reg-p15">Vous pouvez dès maintenant télécharger notre plaquette commerciale en cliquant sur le bouton ci-dessous :</p>
              <div class="d-flex w-100 justify-content-center align-items-center">
                <div class="hortense-btn-primary" @click="downloadPdf()">TÉLÉCHARGER LA PLAQUETTE</div>
              </div>
              <p class="raleway-reg-p15 pt-5">Pour toute question, notre équipe reste à votre disposition via le <span class="link-text">formulaire de contact</span>.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'modal-contact-form',
  props: ["user", "selectedType"],
  data() {
    return {
      isPhone: window.innerWidth <= 768,
      contact: {
        first_name: '',
        last_name: '',
        entreprise: '',
        email: '',
        phone: '',
      },
      formError: false,
      success: false,
    };
  },
  methods: {
    validEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    validateForm() {
      const { first_name, last_name, entreprise, email, phone } = this.contact;
      return (
        first_name &&
        last_name &&
        entreprise &&
        phone &&
        email &&
        this.validEmail(email)
      );
    },
    async submitForm() {
      this.formError = false;

      if (!this.validateForm()) {
        this.formError = true;
        return;
      }

      try {
        const formData = new FormData();
        Object.entries(this.contact).forEach(([key, value]) => {
          formData.append(key, value);
        });

        await fetch("https://formspree.io/f/xovwvepw", {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" }
        });

        this.success = true;
        this.contact = {
          first_name: '',
          last_name: '',
          entreprise: '',
          email: '',
          phone: '',
        };
      } catch (e) {
        alert("Une erreur s'est produite. Veuillez réessayer plus tard.");
      }
    },
    downloadPdf() {
      const pdfUrl = this.selectedType === "entreprise" ? "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/Entreprise+-+Coffret+cadeau+Hortense.pdf" : "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/CSE+-+Coffret+cadeau+Hortense.pdf";
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = this.selectedType === "entreprise" ? "Entreprise-Coffret-cadeau-Hortense.pdf" : "CSE-Coffret-cadeau-Hortense.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
}
</script>
<style scoped lang="scss">
#contact-form-modal {
  .contact-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 85%;
    @media screen and (max-width: 768px) {
      width: 100%;
    }

    img {
      width: 578px;
      height: 410px;
      margin-bottom: 20px;

      @media screen and (max-width: 768px) {
        width: 97%;
        height: 195px; 
      }
    }

    .contact-form {
      background: #FFFFFF 0% 0% no-repeat padding-box;
      @media screen and (max-width: 768px) {
        padding: 10px 0px 10px 0px;
      }

      .line-form {
        label {
          display: flex;
          flex-direction: column;
          font-family: $Raleway;
          font-weight: 600;
          font-size: 15px;
          color: #000000;
          line-height: 18px;
        }
        input[type="text"], input[type="email"], input[type="tel"] {
          padding: 14px;
          gap: 10px;
          height: 42px;
          border: 1px solid #3B6152;
          margin-top: 8px;

          @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
            width: 100%;
          }

          &:focus {
            outline: none;
          }
        }
      }
    }
  }

  .link-text {
    color: #1E6CD6;
    text-decoration: underline;
  }
}

</style>